angular.module('bribac.views.addSchedule', [
  'ngRoute',
  'bribac.entities.scheduleFactory',
  'bribac.services.routeAuth',
  'bribac.components.scheduleEditor',
  'bribac.components.scheduleDetails'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/add/schedule', {
      templateUrl: 'add-schedule-view.html',
      controller: 'AddScheduleViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('AddScheduleViewCtrl', function(
    $location,
    scheduleFactory
  ) {

    var $ctrl = this

    $ctrl.savedEntities = []

    function setNewEntity() {
      $ctrl.entity = scheduleFactory({
        template: true
      })
    }

    $ctrl.successCallback = function(data) {
      $ctrl.savedEntities.push(data)
      setNewEntity()
    }

    // Init

    setNewEntity()

  })
